import { createTheme, ThemeProvider } from '@mui/material';
import cn from 'classnames';
import Image from 'next/image';
import React, { useEffect } from 'react';
import styles from './Support.module.scss';
import { useRouter } from 'next/router';
import { BCBreadcrumbs } from '../index';
import {styled} from "@mui/material/styles";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00454A',
    },
    secondary: {
      main: '#0a0a0a',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
    color: '#0a0a0a',
  },
});
export const Support = () => {
  const router = useRouter();
  useEffect(() => {
    if (router.asPath.includes('#')) {
      const section = router.asPath.split('#')[1];
      document.querySelector(`a[name=${section}]`).scrollIntoView();
    }
  }, [router]);

  const HtmlTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
  ))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  return (
    <ThemeProvider theme={theme}>
      <div className={styles.top}>
        <Image
          className={styles.topImage}
          src={`${process.env.mediaUrl}assets/cookie_front.jpeg`}
          layout="fill"
          objectFit={'cover'}
          objectPosition={'center 70%'}
        />
      </div>
      <div className={cn('container', 'font-libre')}>
        <BCBreadcrumbs headerText="Support" />
        <div className={styles.content}>
          <div id="support" className="menu-marg-fix">
            <div className="row section vision content">
              <div className="column large-16 large-centered">
                <h1 className={cn(styles.welcome, 'font-fragment')}>
                  Welcome to First-Class.com
                </h1>
                <p className="flex justify-center">
                  If you have a question regarding an existing booking please contact our booking team
                  directly:
                </p>
                <div className="flex justify-center">
                  <table className='table-auto'>
                  <thead>
                  <tr>
                    <th>Country / Zone</th>
                    <th>Phone</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Australia</td>
                    <td>+61 2 9061 70 19</td>
                  </tr>
                  <tr>
                    <td>Canada</td>
                    <td>+1 647 956 01 77</td>
                  </tr>
                  <tr>
                    <td>Denmark</td>
                    <td>+45 32 46 30 40</td>
                  </tr>
                  <tr>
                    <td>Great Britain</td>
                    <td>+44 203 455 03 90</td>
                  </tr>
                  <tr>
                    <td>Ireland</td>
                    <td>+35 314 372 539</td>
                  </tr>
                  <tr>
                    <td>India</td>
                    <td>+91 117 181 69 96</td>
                  </tr>
                  <tr>
                    <td>Norway</td>
                    <td>+47 219 361 10</td>
                  </tr>
                  <tr>
                    <td>Sweden</td>
                    <td>+46 8 525 099 29</td>
                  </tr>
                  <tr>
                    <td>United States</td>
                    <td>+1 786 405 85 11</td>
                  </tr>
                  <tr>
                    <td>
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            United Arab Emirates, Brasil, Hong Kong, Indonesia, Israel, Japan, South Korea, Malaysia,
                            New Zealand, Philippines, Qatar, Saudi Arabia, Singapore, Thailand, Taiwan, Vietnam,
                            South Africa
                          </React.Fragment>
                        }
                      >
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <span>English USD Zone</span>
                          <InfoOutlineIcon />
                        </span>
                      </HtmlTooltip>
                    </td>
                    <td>+1 786 405 85 11</td>
                  </tr>
                  <tr>
                    <td>
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            Austria, Belgium, Switzerland, Czechia, Germany, Finland, France, Greece, Italy,
                            Netherlands, Poland, Portugal, Romania, Turkey, Ukraine
                          </React.Fragment>
                        }
                      >
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <span>English Euro Zone</span>
                          <InfoOutlineIcon />
                        </span>
                      </HtmlTooltip>
                    </td>
                    <td>+44 203 455 03 90</td>
                  </tr>
                  <tr>
                    <td>
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            Argentina, Bolivia, Chile, Colombia, Costa Rica, Ecuador, Guatemala, Honduras, México, Nicaragua,
                            Panama, Peru, Puerto Rico, Paraguay, El Salvador, Uruguay
                          </React.Fragment>
                        }
                      >
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <span>Latin America USD Zone</span>
                          <InfoOutlineIcon />
                        </span>
                      </HtmlTooltip>
                    </td>
                    <td>+525 541 614 215</td>
                  </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};
